import BaseApi from './base/BaseApi';

export default class NotificationApi extends BaseApi {
  static entityName = 'notifications';
}
